"use client";

import React from "react";
import { useStore } from "zustand";
import { createCustomerStore, initCustomerStore } from "./store";
import type { CustomerStore } from "./store";

export type CustomerStoreApi = ReturnType<typeof createCustomerStore>;

export const CustomerStoreContext = React.createContext<
  CustomerStoreApi | undefined
>(undefined);

export interface CustomerStoreProviderProps {
  children: React.ReactNode;
}

export const CustomerStoreProvider = ({
  children,
}: CustomerStoreProviderProps) => {
  const storeRef = React.useRef<CustomerStoreApi>(
    createCustomerStore(initCustomerStore()),
  );

  return (
    <CustomerStoreContext.Provider value={storeRef.current}>
      {children}
    </CustomerStoreContext.Provider>
  );
};

export const useCustomerStore = <T,>(
  selector: (store: CustomerStore) => T,
): T => {
  const customerStoreContext = React.useContext(CustomerStoreContext);

  if (!customerStoreContext) {
    throw new Error(
      `useCustomerStore must be used within CustomerStoreProvider`,
    );
  }

  return useStore(customerStoreContext, selector);
};
